


export default {
  state: {
    consultarAdmision: null,
    crearAdmision    : null,
    editarAdmision   : null,
    verAdmision      : null
  },

  mutations: {
    setConsultarAdmision(state, newData) {
      state.consultarAdmision = { ...state.consultarAdmision, ...newData }
    },

    setCrearAdmision(state, newData) {
      state.crearAdmision = { ...state.crearAdmision, ...newData }
    },

    setEditarAdmision(state, newData) {
      state.editarAdmision = { ...state.editarAdmision, ...newData }
    },

    setVerAdmision(state, newData) {
      state.verAdmision = { ...state.verAdmision, ...newData }
    }

  },

};
